import React, { useCallback } from "react";
import PropTypes from "prop-types";
import RightArrow from "@druva-apps/orion-icons/lib/ChevronsmallrightGreyOutline";
import Spinner from "../../spinner/spinner";

const ExpandIcon = ({
  expandable,
  expanded,
  indentSize,
  depth,
  onExpand,
  rowData,
  rowIndex,
  ...rest
}) => {
  const handleClick = useCallback(
    e => {
      e.stopPropagation();
      e.preventDefault();
      onExpand({
        expanded,
        rowData
      });
    },
    [onExpand, expanded, rowData]
  );

  /* istanbul ignore if */
  // if (!expandable && indentSize === 0) {
  //   return null;
  // }

  const iconStyle = {
    transform: `rotate(${expandable && expanded ? 90 : 0}deg)`,
    transition: "transform 0.15s ease-out",
    width: "24px",
    height: "24px"
  };

  if (expandable || (rowData && rowData.shouldExpand)) {
    return (
      <button
        {...rest}
        aria-label="Expand Row"
        type="button"
        onClick={
          (expandable || (rowData && rowData.shouldExpand)) && onExpand
            ? handleClick
            : null
        }
        className="oui-d-block orion-data-grid__row-cell--expand-icon"
      >
        {expanded && (!rowData || !rowData.children) ? (
          <Spinner size="sm" className="oui-align-middle" />
        ) : (
          <RightArrow inheritFontColor size="md" style={iconStyle} />
        )}
      </button>
    );
  }

  return (
    <div
      {...rest}
      href="#"
      className="oui-d-block orion-data-grid__row-cell--expand-icon"
    />
  );
};

ExpandIcon.defaultProps = {
  depth: 0,
  indentSize: 16
};

ExpandIcon.propTypes = {
  expandable: PropTypes.bool,
  expanded: PropTypes.bool,
  indentSize: PropTypes.number,
  depth: PropTypes.number,
  onExpand: PropTypes.func,
  rowIndex: PropTypes.number,
  rowData: PropTypes.object
};

export default ExpandIcon;
